module.exports = __webpack_public_path__ + "static/media/coffeeCup.61788f63.png";